import { useQuery } from 'react-query';
import { AxiosError } from 'axios';
import api from 'services';
import { ApiError } from 'services/api.errors';
import { PortfolioBalanceResponse } from 'services/requests';
import { QueryKeys } from 'constants/queryKeys';

export const useGetEtzProfileBalance = () => {
  const queryFn = () => async () => {
    const { data } = await api.getEtzProfileBalance();
    return data;
  };

  const queryKey = QueryKeys.etzProfileBalance;

  return useQuery<PortfolioBalanceResponse, AxiosError<ApiError>>(queryKey, queryFn());
};
